import MenuItem from '@mui/material/MenuItem';
import TextField, { TextFieldProps } from '@mui/material/TextField';
import * as React from 'react';
import { makeStyles } from 'tss-react/mui';
import { useGetViews } from '../../../../sic-lib/api/hooks/useViews';
import { ViewStyle } from '../../../../sic-lib/types/View';
import { ViewProperty } from '../../../../sic-lib/types/ViewProperty';
import { hasMatchingViewId } from '../../../../sic-lib/utils/functionalFilters';

const useStyles = makeStyles()({
    textField: {
        minWidth: '18ch',
    },
});

type Props = TextFieldProps & {
    onSelectHandler: React.Dispatch<{
        viewId: number;
        viewName: string;
        viewStyle: ViewStyle;
        viewProperties: ViewProperty[];
    }>;
    className?: string;
};

export default function SelectView({ onSelectHandler, className, ...props }: Props) {
    const { classes, cx } = useStyles();

    const { data: viewsData } = useGetViews();

    const views = React.useMemo(() => {
        return viewsData || [];
    }, [viewsData]);

    const handleSelect = (event: React.ChangeEvent<HTMLInputElement>) => {
        const viewId = event.target.value;

        if (viewId) {
            const matchedView = views.filter(hasMatchingViewId(+viewId))[0];

            matchedView &&
                onSelectHandler({
                    viewId: matchedView.viewId,
                    viewName: matchedView.name,
                    viewProperties: matchedView.properties,
                    viewStyle: matchedView.style,
                });
        }
    };

    return (
        <TextField
            {...(props as TextFieldProps)}
            select
            onChange={handleSelect}
            className={cx(classes.textField, className && className)}
        >
            {views.map(vew => (
                <MenuItem
                    key={vew.viewId}
                    value={vew.viewId}
                    data-view-id={vew.viewId}
                    selected={vew.viewId === props.value || false}
                >
                    {vew.name}
                </MenuItem>
            ))}
        </TextField>
    );
}
